export { FavoritesScreen, FavoritesScreenContent } from './FavoritesScreen';
